<template>
    <div>
        <app-header></app-header>
            <div v-on:click="hideBlock">
                <v-layout row wrap>
                    <v-flex xs12 md12 lg12 sm12 class="col-height-auto">
                        <div class="profile-head">
                            <div class="profile-top" :style="{backgroundImage: 'url('+userDetail.coverImage+')'}">
                            </div>
                            <div class="profile-bottom">
                                <div class="user-image text-xs-center mb-3">
                                    <Tooltip :content="'@'+userDetail.userName" placement="right-end">
                                        <!-- <img class="img-responsive rounded-circle pointer" v-bind:src="userDetail.image" @click="openNewWindowViewImage(userDetail.image)"/> -->
                                        <v-avatar color="primary pointer" size="100" @click="openNewWindowViewImage(userDetail.image)">
                                            <img v-show="userDetail.image != null" :src="userDetail.image" :alt="userDetail.userName" />
                                            <span v-show="userDetail.image == null" class="font-50 white--text">
                                                {{ userDetail.userName != null ? userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : ''}}
                                            </span>
                                        </v-avatar>
                                    </Tooltip>
                                    <!--头像预览modal-->
                                    <Modal v-model="isShowViewImageModal">
                                        <p slot="header"></p>
                                        <div>
                                            <img v-bind:src="userDetail.image" style="width: 100%">
                                        </div>
                                        <div slot="footer"></div>
                                    </Modal>
                                </div>
                                <div class="user-list-content mb-5">
                                    <div class="text-xs-center">
                                      <h3 class="fw-700">{{userDetail.nickName}} ({{userDetail.reputationScore}})</h3>
										<div class="font-16 fw-500 mt-3">
										    <span class="mx-3"><v-icon small>fas fa-at</v-icon><span class="ml-1">{{userDetail.userName}}</span></span>
										    <span><v-icon small>fas fa-calendar-alt</v-icon><span class="ml-1">{{regTimeFormat(userDetail.regTime)}}</span></span>
										</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
                <v-container grid-list-xl mb-5 align-center justify-center>
                    <v-layout row wrap justify-center>
                        <v-flex xs12 sm4 md3 lg3 xl2 class="inbox-sidebar">
                            <div class="inbox-head">
                                <div class="mailbox-items-warp">
                                    <div class="app-card">
                                        <v-list>
                                            <v-list-tile @click="getMenuData('following')">
                                                <v-list-tile-action>
                                                  <v-icon>group_add</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{$t("follow.following")}}({{followingNum}})
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile @click="getMenuData('followers')">
                                                <v-list-tile-action>
                                                  <v-icon>group</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{$t("follow.followers")}}({{followerNum}})
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile class="d-none" @click="getMenuData('referrals')">
                                                <v-list-tile-action>
                                                  <v-icon>accessibility</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{$t("follow.referrals")}}({{userDetail.invitationNumber}})
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile class="d-none" @click="getMenuData('collections')">
                                                <v-list-tile-action>
                                                  <v-icon>fa fa-star</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{$t("follow.collections")}}({{totalPostingNum}})
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                    </div>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm9 class="inbox-content">
                            <div class="inbox-content-wrap">
							  <v-card>
								<v-container fluid>
                                <!-- - - - - - - - - - - - - - - - - 我的关注 - - - - - - - - - - - - - - - - -->
                                <div v-show="isShowFollowing" class="ml-3 mr-3">
                                    <!-- <Table stripe border :show-header="false" :columns="followingColumns" :data="followingList" height="300" :no-data-text="$t('follow.followingTableMsg')"></Table> -->
                                    <v-container fluid grid-list-xl pt-2>
                                        <v-layout row wrap>
                                            <div class="mr-3 mb-3 app-card" v-for="(user, index) in followingList" :key="index">
                                                <div class="text-xs-center follow-w mb-3 mt-2 profile-card-bg" :style="{backgroundImage: 'url('+user.coverImage+')'}">
                                                    <v-avatar color="primary" class="pointer mt-4" size="40" @click=goUserData(user.userName)>
                                                        <img v-show="user.image != null" :src="user.image" :alt="user.userName" />
                                                        <span v-show="user.image == null" class="headline white--text">
                                                          {{ user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '' }}
                                                        </span>
                                                    </v-avatar>
                                                </div>
                                                <div class="user-list-content">
                                                    <div class="text-xs-center pt-2">
                                                        <h4 class="fw-bold pointer" @click=goUserData(user.userName)>{{user.nickName}}</h4>
                                                        <span>@{{user.userName}}</span>
                                                    </div>
                                                    <div class="text-xs-center mb-2">
                                                        <div v-show="user.userId != userId">
                                                            <v-btn class="primary" dark small  @click="following(user.userId)">
                                                                <span v-show="user.status == '1' ? true : false">
                                                                    {{$t("common.unfollow")}}
                                                                </span>
                                                                <span v-show="user.status == '1' ? false : true">
                                                                    <Icon type="plus-round" color="#FFFFFF"></Icon>
                                                                    {{$t("common.follow")}}
                                                                </span>
                                                            </v-btn>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-layout>
                                    </v-container>
                                </div>
                                <!-- - - - - - - - - - - - - - - -我的粉丝- - - - - - - - - - - - - - - -->
                                <div v-show="isShowFollowers" class="ml-3 mr-3">
                                    <!-- <Table stripe border :show-header="false" :columns="followerColumns" :data="followerList" height="300"  :no-data-text="$t('follow.followerTableMsg')"></Table> -->
                                    <v-container fluid grid-list-xl pt-2>
                                        <v-layout row wrap>
                                            <div class="mr-3 mb-3 app-card" v-for="(user, index) in followerList" :key="index">
                                                <div class=" text-xs-center follow-w mb-3 mt-2 profile-card-bg" :style="{backgroundImage: 'url('+user.coverImage+')'}">
                                                    <v-avatar color="primary" class="pointer mt-4" size="40" @click=goUserData(user.userName)>
                                                        <img v-show="user.image != null" :src="user.image" :alt="user.userName" />
                                                        <span v-show="user.image == null" class="headline white--text">
                                                          {{ user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '' }}
                                                        </span>
                                                    </v-avatar>
                                                </div>
                                                <div class="user-list-content">
                                                    <div class="text-xs-center pt-2">
                                                        <h4 class="fw-bold pointer" @click=goUserData(user.userName)>{{user.nickName}}</h4>
                                                        <span>@{{user.userName}}</span>
                                                    </div>
                                                    <div class="text-xs-center mb-2">
                                                        <div v-if="user.userId != userId">
                                                            <v-btn class="primary" dark small  @click="follower(user.userId)">
                                                                <span v-show="user.status == '1' ? true : false">
                                                                    {{$t("common.unfollow")}}
                                                                </span>
                                                                <span v-show="user.status == '1' ? false : true">
                                                                    <Icon type="plus-round" color="#FFFFFF"></Icon>
                                                                    {{$t("common.follow")}}
                                                                </span>
                                                            </v-btn>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-layout>
                                    </v-container>
                                </div>
                                <!-- - - - - - - - - - - - - - - -我的推荐- - - - - - - - - - - - - - - -->
                                <div v-show="isShowReferrals" class="ml-3 mr-3">
                                    <v-container fluid grid-list-xl pt-2>
                                        <v-layout row wrap>
                                            <div class="mr-3 mb-3 app-card" v-for="(user, index) in referralList" :key="index">
                                                <div class=" text-xs-center follow-w mb-3 mt-2 profile-card-bg" :style="{backgroundImage: 'url('+user.coverImage+')'}">
                                                    <v-avatar color="primary" class="pointer mt-4" size="40" @click=goUserData(user.userName)>
                                                        <img v-show="user.image != null" :src="user.image" :alt="user.userName" />
                                                        <span v-show="user.image == null" class="headline white--text">
                                                          {{ user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '' }}
                                                        </span>
                                                    </v-avatar>
                                                </div>
                                                <div class="user-list-content">
                                                    <div class="text-xs-center pt-2">
                                                        <h4 class="fw-bold pointer" @click=goUserData(user.userName)>{{user.nickName}}</h4>
                                                        <span>@{{user.userName}}</span>
                                                    </div>
                                                    <div class="text-xs-center mb-2">
                                                        <div v-if="user.userId != userId">
                                                            <v-btn class="primary" dark small  @click="referralFollow(user.userId)">
                                                                <span v-show="user.status == '1' ? true : false">
                                                                    {{$t("common.unfollow")}}
                                                                </span>
                                                                <span v-show="user.status == '1' ? false : true">
                                                                    <Icon type="plus-round" color="#FFFFFF"></Icon>
                                                                    {{$t("common.follow")}}
                                                                </span>
                                                            </v-btn>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-layout>
                                    </v-container>
                                </div>
                                <!-- - - - - - - - - - - - - - - -我的喜欢- - - - - - - - - - - - - - - -->
                                <div v-show="isShowCollections">
                                    <div v-for="(posting,index) in postingList" class="media-listing">
                                    <ul class="list-unstyled">
                                        <li class="media border-bottom-light-1">
                                            <!-- - - - - - - - - - -  帖子图片- - - - - - - - - - - - - - -->
                                            <span class="rounded-circle mr-4 img-responsive posting-image" v-if="posting.postingImg!=''" v-html="posting.postingImg" >
                                            </span>
                                            <div class="media-body">
                                                <!-- - - - - - - - - - -  标题- - - - - - - - - - - - - - -->
                                                <h3 class="fw-bold" @click="getPostingById(posting.postingId)">
                                                    <b>{{posting.postingTitle}}</b>
                                                </h3>
                                                <p class="mb-0">
                                                    <span v-if="posting.postingContent.length = 0"></span>
                                                    <span v-if="posting.postingContent.length < 30">
                                                        {{posting.postingContent}}
                                                    </span>
                                                    <span v-else>{{posting.postingContent}}……</span>
                                                </p>
                                                <div class="social-list clearfix mb-4">
                                                    <ul class="list-inline d-inline-block">
                                                        <li @click="getPostingById(posting.postingId,posting.postingUserId)">
                                                           <!--  <i class="ti-angle-up"></i> <span>{{posting.postingGoodnums}}</span> -->
                                                              <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">thumb_up_alt</v-icon><span>{{posting.postingGoodnums}}</span>
                                                        </li>
                                                        <li>
                                                           <!--  <i class="ti-angle-down"></i> <span>{{posting.postingStepnums}}</span> -->
                                                             <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">thumb_down_alt</v-icon><span>{{posting.postingStepnums}}</span>
                                                        </li>
                                                        <li>
                                                            <!-- <i class="ti-comment"></i><span>{{posting.postingCountComments}}</span> -->
                                                            <v-icon small @click="getPostingById(posting.postingId,posting.postingUserId)">fa fa-comment</v-icon><span>{{posting.postingCountComments}}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div v-show="postingList.length > 0">
                                    <Page :total="totalPostingNum" :pageSize="5" size="small" transfer @on-change="getPostingByPage" class="mt-2 mb-5 text-xs-center"></Page>
                                </div>
                                </div>
								</v-container>
								</v-card>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
    </div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    import {eventBus} from '../../assets/js/eventBus.js'
    export default {
        data(){
            return{
                userId: this.$store.state.user.id,
                username: this.$route.params.username,//用户名
                userDetail: {},                 //用户详情对象
                isShowViewImageModal: false,    //是否显示查看大图的modal
                isShowFollowing: true,          //是否显示我关注的用户div
                isShowFollowers: false,         //是否显示关注我的用户div
                isShowReferrals: false,         //是否显示关注我的推荐div
                isShowCollections: false,       //是否显示我收藏的帖子div
                followingList: [],              //我关注的user集合
                followerList: [],               //关注我的user集合
                referralList: [],               //我的推荐人集合
                postingList: [],                //该用户的帖子集合
                followingNum: 0,                //我关注的人数
                followerNum: 0,                 //我的粉丝人数
                totalPostingNum: 0,             //总帖子数
                userIdArray: [],                //userId数组，用来查询是否关注
                formCollection: {
                    userId: '',
                    postingId: '',
                },
                formFollow: {               //关注对象
                    userId: '',
                    followerId: '',
                },
                followingColumns: [         //我关注的表格字段
                    {
                        type: 'index',
                        width: 100
                    },
                    {
                        render: (h, params) => {
                            return h('div', [
                                h('strong', {
                                    style: {
                                        cursor: 'pointer',
                                        color: '#41B8BC',
                                    },
                                    on: {
                                        click: () => {
                                            let routeData = this.$router.resolve({
                                            name:'userData',
                                            params: {
                                                username: params.row.userName
                                            }
                                        });
                                        window.open(routeData.href, '_blank');
                                        }
                                    }
                                }, params.row.userName),
                            ]);
                        },
                    },
                    {
                        width: 200,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    style: {
                                        background: '#41B8BC',
                                        color: '#FFFFFF'
                                    },
                                    on: {
                                        click: () => {
                                            this.following(params.row.id, params.index);
                                        }
                                    }
                                }, this.$t("common.unfollow"))
                            ]);
                        },
                    }
                ],
                followerColumns: [              //关注我的表格字段
                    {
                        type: 'index',
                        width: 100
                    },
                    {
                        render: (h, params) => {
                            return h('div', [
                                h('strong', {
                                    style: {
                                        cursor: 'pointer',
                                        color: '#41B8BC',
                                    },
                                    on: {
                                        click: () => {
                                            let routeData = this.$router.resolve({
                                            name:'userData',
                                            params: {
                                                username: params.row.userName
                                            }
                                        });
                                        window.open(routeData.href, '_blank');
                                        }
                                    }
                                }, params.row.userName),
                            ]);
                        },
                    },
                    {
                        width: 200,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    style: {
                                        marginRight: '5px',
                                        background: '#41B8BC',
                                        color: '#FFFFFF'
                                    },
                                    on: {
                                        click: () => {
                                            this.follower(params.row.userId);
                                        }
                                    }
                                }, this.isFollow(params.row.userId)?this.$t("common.unfollow"):this.$t("common.follow"))
                            ]);
                        },
                    }
                ],
            }
        },
        computed: {

        },
        created(){

        },
        mounted:function(){
            if (this.$route.params.username) {
                if (this.$route.params.username.indexOf('@') == 0) {
                    this.username = this.$route.params.username.substring(1);
                }
                this.getUserDetail();
                this.initCount();
                this.getMenuData('following');
            }
        },
        watch:{
            //监听路由的username变化之后就重新加载页面
            $route(){
                if (this.$route.params.username) {
                    if (this.$route.params.username.indexOf('@') == 0) {
                        this.username = this.$route.params.username.substring(1);
                    } else {
                        this.username = this.$route.params.username;
                    }
                }
            },
            username() {
                if (this.username) {
                    //加载基础数据
                    this.initCount();
                    //记载用户数据
                    this.getUserDetail();
                    //加载帖子选项
                    this.getMenuData("following");
                }
            },
        },
        methods: {
            //切换菜单加载数据
            getMenuData(name){
                //看路由过来的是需要打开哪个选项卡
                let followOption = sessionStorage.getItem("followOption");
                if (followOption) {
                    name = followOption;
                    sessionStorage.removeItem("followOption");
                }
                switch (name) {
                    case "following":
                        this.isShowFollowing = true;
                        this.isShowFollowers = false;
                        this.isShowReferrals = false;
                        this.isShowCollections = false;
                        this.getFollowingList();
                        break;
                    case "followers":
                        this.isShowFollowing = false;
                        this.isShowFollowers = true;
                        this.isShowReferrals = false;
                        this.isShowCollections = false;
                        this.getFollowerList();
                        break;
                    case "referrals":
                        this.isShowFollowing = false;
                        this.isShowFollowers = false;
                        this.isShowReferrals = true;
                        this.isShowCollections = false;
                        this.getReferralList();
                        break;
                    case "collections":
                        this.isShowFollowing = false;
                        this.isShowFollowers = false;
                        this.isShowReferrals = false;
                        this.isShowCollections = true;
                        this.getCollectionPostingList();
                        break;
                    default:
                        this.isShowFollowing = true;
                        this.isShowFollowers = false;
                        this.isShowReferrals = false;
                        this.isShowCollections = false;
                        this.getFollowingList();
                        break;
                }
            },
            //判断用户是否关注了关注自己的人
            isFollow(followerId){
                if(this.followingList != null && this.followingList.length > 0){
                    for (var i = 0; i < this.followingList.length; i++) {
                        if (this.followingList[i].userId == followerId) {
                            return true;
                        }
                    }
                }
                return false;
            },
            //加载各种数量
            initCount(){
                this.$http.get(config.baseUrl + "follow/open/countFollowingByUsername/"+this.username).then(successData => {
                    this.followingNum = successData.data.result;
                });
                this.$http.get(config.baseUrl + "follow/open/countFollowerByUsername/"+this.username).then(successData => {
                    this.followerNum = successData.data.result;
                });
                this.$http.get(config.baseUrl + "collection/open/countPostingByUsername/"+this.username).then(successData => {
                    this.totalPostingNum = successData.data.result;
                });
            },
            //加载用户数据
            getUserDetail(){
                //查询用户信息
                this.$http.get(config.baseUrl + "userDetail/open/getUserInfo/" + this.username).then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.userDetail = data.result;
                        document.title = this.userDetail.nickName + "(@" + this.userDetail.userName + ")——SiP";
                    }else{
                        this.$router.push({name: 'page404'});
                    }
                });
            },
            //查看头像大图
            viewBigImage(){
                this.isShowViewImageModal = true;
            },
            //获得我关注的user集合
            getFollowingList(){
                this.$http.get(config.baseUrl + "follow/open/getFollowingByUsername/"+ this.username).then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.followingList = data.result;
                        this.followingNum = data.result.length;
                        // if (localStorage.getItem("token")) {
                        //     this.getIsFollowByUserId("following");
                        // }
                    }else{
                        this.followingList = [];
                        this.followingNum = 0;
                    }
                });
            },
            //获得我的粉丝user集合
            getFollowerList(){
                this.$http.get(config.baseUrl + "follow/open/getFollowerByFollowername/"+ this.username).then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.followerList = data.result;
                        this.followerNum = data.result.length;
                        // if (localStorage.getItem("token")) {
                        //     this.getIsFollowByUserId("followers");
                        // }
                    }else{
                        this.followerList = [];
                        this.followerNum = 0;
                    }
                });
            },
            //获得我的推荐的人的集合
            getReferralList(){
                this.$http.get(config.baseUrl + "follow/open/getReferralsByUsername/"+ this.username).then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.referralList = data.result;
                        this.userDetail.invitationNumber = data.result.length;
                        // if (localStorage.getItem("token")) {
                        //     this.getIsFollowByUserId("referrals");
                        // }
                    }else{
                        this.referralList = [];
                        this.userDetail.invitationNumber = 0;
                    }
                });
            },
            //正在关注
            following(followerId){
                if (localStorage.getItem("token")) {
                    this.formFollow.userId = this.$store.state.user.id;
                    this.formFollow.followerId = followerId;
                    this.$http.post(config.baseUrl + "follow/saveFollow", this.formFollow).then((successData) => {
                        let data = successData.data;
                        if (data.resCode == 0) {
                            // this.$Message.success("Success!");
                            // "1"代表已经关注
                            for (var i = 0; i < this.followingList.length; i++) {
                                if (this.followingList[i].userId == followerId) {
                                    this.followingList[i].status = "1";
                                }
                            }
                            if (this.username == this.$store.state.user.name) {
                                this.followingNum += 1;
                            }
                        } else if (data.resCode == 1) {
                            // this.$Message.info("Cancel Follow!");
                            // this.followingList.splice(index, 1);
                            // "0"代表没有关注
                            for (var i = 0; i < this.followingList.length; i++) {
                                if (this.followingList[i].userId == followerId) {
                                    this.followingList[i].status = "0";
                                }
                            }
                            if (this.username == this.$store.state.user.name) {
                                this.followingNum -= 1;
                            }
                        } else if (data.resCode == -3) {
                            this.$Message.error("Can not follow yourself!");
                        }
                    });
                }else{
                    this.$store.state.loginModal = true;
                }
            },
            //关注者
            follower(followerId){
                if (localStorage.getItem("token")) {
                    this.formFollow.userId = this.$store.state.user.id;
                    this.formFollow.followerId = followerId;
                    this.$http.post(config.baseUrl + "follow/saveFollow", this.formFollow).then((successData) => {
                        let data = successData.data;
                        if (data.resCode == 0) {
                            for (var i = 0; i < this.followerList.length; i++) {
                                if (this.followerList[i].userId == followerId) {
                                    this.followerList[i].status = "1";
                                }
                            }
                            if (this.username == this.$store.state.user.name) {
                                this.followingNum += 1;
                            }
                        } else if (data.resCode == 1) {
                            // this.$Message.info("Cancel Follow!");
                            for (var i = 0; i < this.followerList.length; i++) {
                                if (this.followerList[i].userId == followerId) {
                                    // this.followingList.splice(i, 1);
                                    // break;
                                    this.followerList[i].status = "0";
                                }
                            }
                            if (this.username == this.$store.state.user.name) {
                                this.followingNum -= 1;
                            }
                        } else if (data.resCode == -3) {
                            this.$Message.error(this.$t('follow.canNotFollow'));
                        }
                    });
                }else{
                    this.$store.state.loginModal = true;
                }
            },
            //推荐人的关注与取消
            referralFollow(followerId){
                if (localStorage.getItem("token")) {
                    this.formFollow.userId = this.$store.state.user.id;
                    this.formFollow.followerId = followerId;
                    this.$http.post(config.baseUrl + "follow/saveFollow", this.formFollow).then((successData) => {
                        let data = successData.data;
                        if (data.resCode == 0) {
                            for (var i = 0; i < this.referralList.length; i++) {
                                if (this.referralList[i].userId == followerId) {
                                    this.referralList[i].status = "1";
                                }
                            }
                            this.followingNum += 1;
                        } else if (data.resCode == 1) {
                            for (var i = 0; i < this.referralList.length; i++) {
                                if (this.referralList[i].userId == followerId) {
                                    this.referralList[i].status = "0";
                                }
                            }
                            this.followingNum -= 1;
                        } else if (data.resCode == -3) {
                            this.$Message.error("Can not follow yourself!");
                        }
                    });
                }else{
                    this.$store.state.loginModal = true;
                }
            },
            //根据userId与userId数组查询该用户是否关注这些人
            getIsFollowByUserId(name){
                this.userIdArray = [];
                switch (name) {
                    case 'following':
                        for(var i = 0; i < this.followingList.length; i++){
                            this.userIdArray[i] = this.followingList[i].userId;
                        }
                        break;
                    case 'followers':
                        for(var i = 0; i < this.followerList.length; i++){
                            this.userIdArray[i] = this.followerList[i].userId;
                        }
                        break;
                    case 'referrals':
                        for(var i = 0; i < this.referralList.length; i++){
                            this.userIdArray[i] = this.referralList[i].userId;
                        }
                        break;
                    default:
                        break;
                }
                if (this.userIdArray.length == 0) {
                    //如果数组长度为零，不用查询
                    return;
                }
                let url = config.baseUrl + "follow/getIsFollowByUserId/" + this.userId;
                this.$http.post(url, this.userIdArray).then(successData => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        switch (name) {
                            case 'following':
                                for(var i = 0; i < this.followingList.length; i++){
                                    for(var j = 0; j < data.result.length; j++){
                                        if (this.followingList[i].userId == data.result[j].followerId) {
                                            this.followingList[i].status = "1";
                                        }
                                    }
                                }
                                break;
                            case 'followers':
                                for(var i = 0; i < this.followerList.length; i++){
                                    for(var j = 0; j < data.result.length; j++){
                                        if (this.followerList[i].userId == data.result[j].followerId) {
                                            this.followerList[i].status = "1";
                                        }
                                    }
                                }
                                break;
                            case 'referrals':
                                for(var i = 0; i < this.referralList.length; i++){
                                    for(var j = 0; j < data.result.length; j++){
                                        if (this.referralList[i].userId == data.result[j].followerId) {
                                            this.referralList[i].status = "1";
                                        }
                                    }
                                }
                                break;
                            default:
                                break;
                        }
                    }
                });
            },
            //根据id查看帖子详情
            getPostingById(postingId, userId) {
                this.$router.push({
                    name: 'postingsel',
                    params: {
                        postingId: postingId,
                        userId: userId
                    }
                });
            },
            //分页查询用户的帖子
            getCollectionPostingList(){
                let postingUrl = config.baseUrl + "collection/open/getPostingByUsername/" + this.username + "/0/5";
                this.$http.get(postingUrl).then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.postingList = data.result.postingList;
                        this.totalPostingNum = data.result.totalElements;
                    } else if (data.resCode == -1) {
                        this.postingList = [];
                        this.totalPostingNum = 0;
                    }
                });
            },
            //分页查询用户的帖子
            getPostingByPage(pageNo){
                let postingUrl = config.baseUrl + "collection/open/getPostingByUsername/" + this.username + "/" + (pageNo - 1) + "/5";
                this.$http.get(postingUrl).then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.postingList = data.result.postingList;
                        this.totalPostingNum = data.result.totalElements;
                    } else if (data.resCode == -1) {
                        this.postingList = [];
                        this.totalPostingNum = 0;
                        this.$Notice.info({
                            title: "You don't have any collections yet."
                        });
                    }
                });
            },
            //取消收藏
            collectionPosting: function(postingId) {
                this.formCollection.userId = this.$store.state.user.id;
                this.formCollection.postingId = postingId;
                this.$http.post(config.baseUrl + "collection/saveCollectionPosting", this.formCollection).then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                    } else if (data.resCode == 1) {
                        this.getPostingByPage(1);
                    }
                });
            },
            //路由到查看用户详情页面
            goUserData:function(username){
                this.$router.push({
                    name:'userData',
                    params: {
                        username: '@' + username
                    }
                });
            },
            //打开新窗口预览图片
            openNewWindowViewImage(imageUrl){
                if (imageUrl) {
                    window.open(imageUrl);
                }
            },
            //点击其它区域隐藏区块
            hideBlock(event){

            },
            //格式化注册时间
            regTimeFormat(time) {
                return formatTime(time, this.$i18n.locale);
            },
        },

    }
</script>



// WEBPACK FOOTER //
// UserFollow.vue?01c5f35a